import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface UpAnimationProps {
  children: ReactNode;
}

const UpAnimation: React.FC<UpAnimationProps> = ({ children }) => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  const variants = {
    hidden: { opacity: 0, y: 100 },   // Come from bottom
    visible: { opacity: 1, y: 0 },    // In place
    exit: { opacity: 0, y: -100 },    // Exit to top
  };

  return (
    <motion.div
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={inView ? 'visible' : 'exit'}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      style={{ margin: '0 0' }}
    >
      {children}
    </motion.div>
  );
};

export default UpAnimation;